// extracted by mini-css-extract-plugin
module.exports = {"grid-container":"Grid_grid-container__2ZI2N"};